module.exports = __webpack_public_path__ + "img/daniel-moura.8e2e047f.png";